import { PageHeading } from "@via/components/page-heading.tsx";
import { HorizontalTabs } from "@via/components/tabs.tsx";
import { PAGE_NAMES, PROFILE_TABS, USER_ROLES } from "@via/utils/constants.tsx";
import { type JSX, useMemo } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "@via/hooks/useAuth.tsx";
import ImpersonationSelectComponent from "@via/pages/account/profile/impersonation-select-component.tsx";
import { useConfigurations } from "@via/api/configuration";

export default function Profile(): JSX.Element {
  const { user } = useAuth();
  const isAdmin = user?.userRole === USER_ROLES.ADMIN;
  const { data: configurations } = useConfigurations();
  const mfaMode = configurations?.MFA_ENFORCEMENT ?? "off";

  // Filter tabs based on feature flags
  const visibleTabs = useMemo(() => {
    return PROFILE_TABS.filter(tab => {
      // Hide Personal Access Tokens / Connect AI Assistants tabs if FF_PAT feature flag is not enabled
      if (
        tab.href === "personal-access-tokens" ||
        tab.href === "connect-claude"
      ) {
        return user?.featureFlags?.FF_PAT === true;
      }
      // Multi-factor sign-in settings mean nothing while the installation has it off.
      if (tab.href === "security") {
        return mfaMode !== "off";
      }
      return true;
    });
  }, [user?.featureFlags, mfaMode]);

  return (
    <main className="via-content-wrapper">
      <div className="flex flex-wrap justify-between">
        <PageHeading title={PAGE_NAMES.PROFILE} />
        {isAdmin ? <ImpersonationSelectComponent /> : null}
      </div>
      <HorizontalTabs
        buttonIdPrefix="environment-settings"
        options={visibleTabs}
      />
      <main className="py-6">
        <Outlet />
      </main>
    </main>
  );
}
